import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function AdminGuard({ children }) {
  const account = useSelector((state) => state.account);
  const isAdminOrManager =
    account !== null &&
    account.user !== null &&
    (account.user.isAdmin || account.user.isManager || account.user.isManagerOfUsers);

  if (!isAdminOrManager) {
    return <Redirect to="/login" />;
  }

  return children;
}

AdminGuard.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default AdminGuard;
